import "@fontsource/lato"
import "@fontsource/roboto-serif"
import './src/styles/global.css'
require('./src/styles/prism-atom-dark.css')
